import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

import { appConfigsApi } from 'api';
import { AppConfigArea, AppConfigKey } from 'enums';
import { AppConfig } from 'types';

export function useAppConfigValue<TError>(
  params: { area: AppConfigArea; key: AppConfigKey; isPublic?: boolean },
  options?:
    | Omit<
        UseQueryOptions<any, TError, AppConfig, string>,
        'queryKey' | 'queryFn'
      >
    | undefined,
): UseQueryResult<AppConfig> {
  return useQuery(
    `app-config-${params.area}-${params.key}`,
    appConfigsApi.getAppConfigValue(params),
    options,
  );
}
